export const enum IRATypes {
  /**
   * This key refers to the 'Traditional, rollover or SEP-IRA' option on the iratype page
   */
  OTHER = 'OTHER', // Traditional IRA
  ROTH = 'ROTH',
  INHERITED_OTHER = 'INHERITED-OTHER', // Inherited Traditional IRA
  INHERITED_ROTH = 'INHERITED-ROTH',
  UNKNOWN = '',
}

export const enum IRAOptions {
  ASSUME = 'assume',
  INHERIT = 'inherit',
  UNKNOWN = '',
}
